import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { PortfolioHoldingsType } from "@/app/dashboard/types";

interface PortfolioHoldingsState {
  portfolios: PortfolioHoldingsType[];
  focusedPortfolio?: PortfolioHoldingsType;
  loaded: boolean;
}

const initialState: PortfolioHoldingsState = {
  portfolios: [],
  focusedPortfolio: undefined,
  loaded: false,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setPortfolios(state, action: PayloadAction<PortfolioHoldingsType[]>) {
      if (Array.isArray(action.payload)) state.portfolios = action.payload;
      else state.focusedPortfolio = action.payload;
      state.loaded = true;
    },
    setFocusedPortfolio(state, action: PayloadAction<PortfolioHoldingsType>) {
      state.focusedPortfolio = action.payload;
    },
    resetLoadedState(state) {
      state.loaded = false;
    },
  },
  extraReducers: (builder) => {
    builder.addCase("clear", () => {
      return initialState;
    });
  },
});

export const { setPortfolios, setFocusedPortfolio, resetLoadedState } =
  dashboardSlice.actions;
export default dashboardSlice.reducer;
